module.exports = __webpack_public_path__ + "f84b857901caada89c64435b5d28fa30.jpg";